import React, { useState, Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { LabelTooltipProps } from './types';

const LabelTooltip: React.FC<LabelTooltipProps> = ({ label, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoverTimer, setHoverTimer] = useState<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 300); // 300ms delay before showing tooltip
    setHoverTimer(timer);
  };

  const handleMouseLeave = () => {
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      setHoverTimer(null);
    }
    setIsOpen(false);
  };

  return (
    <Popover className="relative">
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Popover.Button as="div" className="cursor-default">
          {children}
        </Popover.Button>
      </div>

      <Transition
        show={isOpen}
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <Popover.Panel
          static
          className="absolute z-10 mt-2 w-80 transform"
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="bg-white p-4">
              <div className="font-semibold text-sm mb-2">{label.label_name}</div>
              <div className="text-xs space-y-2">
                <div>
                  <span className="font-medium text-gray-700">Reasoning:</span>
                  <p className="mt-1 text-gray-600">{label.rationale}</p>
                </div>
                {label.regulation_reference && (
                  <div>
                    <span className="font-medium text-gray-700">Regulation:</span>
                    <p className="mt-1 text-gray-600">{label.regulation_reference}</p>
                  </div>
                )}
                <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                  <span className="font-medium text-gray-700">Confidence:</span>
                  <span className="text-gray-900 font-semibold">
                    {(label.confidence * 100).toFixed(0)}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
};

export default LabelTooltip;